import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DlGroupList from "./pages/dl_group/DlGroupList";
import ToLogin from "./pages/auth/ToLogIn";
import ToLogout from "./pages/auth/ToLogout";
import AdminPhotoSeries from "./pages/photo_series/AdminPhotoSeries";
import AdmStart from "./pages/common/AdmStart";
import AdminLayout from "./layout/AdminLayout";
import { useAuthCurrent } from "hooks/auth/auth_current";
import { AddNavigationProvider } from "common/modal/AddNavigation";
import DlUnitList from "./pages/auth/DlUnitList";
import DlGroupEdit from "./pages/dlgroup/DlGroupEdit";
import DlUnitEdit from "./pages/dlUnit/DlUnitEdit";
import AdminPhotoSeriesEdit from "./pages/photoSeries/AdminPhotoSeriesEdit";
import Users from "./pages/user/Users";

export default function AdmApp() {
  const authCurrent = useAuthCurrent();
  const navigate = useNavigate();
  useEffect(() => {
    // console.log("authCurrent", authCurrent);
    if (!authCurrent || !authCurrent.un || authCurrent.un === "") {
      navigate("/l-in");
    }
  }, [authCurrent]);

  return (
    <AddNavigationProvider>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<AdmStart />} />
          <Route path="l-in" element={<ToLogin />} />
          <Route path="l-out" element={<ToLogout />} />
          <Route path="dl-group-li" element={<DlGroupList />} />
          <Route path="dl-group-edit" element={<DlGroupEdit />} />
          <Route path="photo-ser-li" element={<AdminPhotoSeries />} />
          <Route path="photo-ser-edit" element={<AdminPhotoSeriesEdit />} />
          <Route path="user-li" element={<Users />} />
          <Route path="dl-unit-li" element={<DlUnitList />} />
          <Route path="dl-unit-edit" element={<DlUnitEdit />} />
        </Route>
      </Routes>
    </AddNavigationProvider>
  );
}
